import { Connector } from '@web3-react/types'
import WALLET_CONNECT_ICON_URL from 'assets/images/walletConnectIcon.svg'
import { ConnectionType, walletConnectV2Connection } from 'connection'
import { getConnectionName } from 'connection/utils'

import { useToggleWalletModal } from '../../state/application/hooks'
import Option from './Option'

const BASE_PROPS = {
  color: '#4196FC',
  icon: WALLET_CONNECT_ICON_URL,
  id: 'wallet-connect',
}

export function WalletConnectV2Option({ tryActivation }: { tryActivation: (connector: Connector) => void }) {
  const isActive = walletConnectV2Connection.hooks.useIsActive()
  const ToggleWalletModal = useToggleWalletModal()
  const OnClick = () => {
    setTimeout(ToggleWalletModal, 1500)
    tryActivation(walletConnectV2Connection.connector)
  }
  return (
    <Option
      {...BASE_PROPS}
      isActive={isActive}
      onClick={OnClick}
      header={getConnectionName(ConnectionType.WALLET_CONNECT_V2)}
    />
  )
}
